import React, {Component} from 'react';

import _ from 'lodash';

class Button extends Component {

    colorGradient = () => {
        const { 
            colors, gradientBegin, gradientEnd, disabled,
            outline
        } = this.props;
        if(disabled){
            return '#ced6e0';
        }

        if(_.isUndefined(colors)) {
            return [outline ? 'transparent' : gradientBegin, outline ? 'transparent' : gradientEnd];
        } else {
            if (_.isString(colors)){
                return [outline ? 'transparent' : colors, outline ? 'transparent' : colors]
            } else {
                return [outline ? 'transparent' : colors[0], outline ? 'transparent' : colors[1]];
            }
        }
    }

    getStyle = () => {
        const { 
            rounded, radius, outline, colors, gradientBegin,
            style
        } = this.props;
        const customButtonStyle = {...style};
        const customTextStyle = { color: '#fff'};

        if(rounded) customButtonStyle['borderRadius'] = radius;
        if(outline) {
            customButtonStyle['border'] = '.2rem solid';
            customButtonStyle['background'] = 'transparent';
            if(_.isUndefined(colors)) {
                customButtonStyle['borderColor'] = gradientBegin;
                customTextStyle['color'] = gradientBegin;
            } else if (_.isString(colors)) {
                customButtonStyle['borderColor'] = colors;
                customTextStyle['color'] = colors;
            } else {
                customButtonStyle['borderColor'] = colors[0];
                customTextStyle['color'] = colors[0];
            }
        }


        return {customButtonStyle, customTextStyle};
    }

    render() {
        const {
            onClick, children, text, textStyle, disabled,
            outline, buttonType, type, animated
        } = this.props;
        const {customButtonStyle, customTextStyle } = this.getStyle();
        return (
            <button className={`button ${animated ? 'button--animated' : ''} button${buttonType ? '__'+buttonType : ''} ${outline ? 'button--outline' : ''}` }
                style={customButtonStyle}
                disabled={disabled}
                onClick={onClick}
                type={type || 'button'}
            >
                {text ? <span className="button__text" style={{...customTextStyle,...textStyle}}>{text}</span> : children}
            </button>
        );
    }
}

Button.defaultProps = {
    disabled: false,
    gradientBegin: '#2980b9',
    gradientEnd: '#07507F',
    gradientDirection: 'diagonal',
    height: 50,
    radius: 50
};

export default Button;